var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-take-page"},[_c(_setup.Loading,{attrs:{"active":_setup.isLoading}}),_c(_setup.CourseTakeNavbar),(_setup.course)?_c('div',{staticClass:"course-take-page__body"},[_c(_setup.Box,[_c(_setup.ActiveItem)],1),_c(_setup.CourseTakeButtons)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }